import { Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import { Checkmark } from '../Checkmark'
import * as Styled from './styles'

interface QuestionProps {
  content: ReactNode
  isAnswered?: boolean
  title: string
  questionNumber: number
  sideActions?: ReactNode
}

export const Question = ({ title, content, isAnswered, sideActions, questionNumber }: QuestionProps): ReactElement => {
  return (
    <Styled.QuestionWrapper>
      <Styled.TitleWrapper>
        <Text colorVariant={isAnswered ? 'success' : 'primary'} variant="h4">
          {questionNumber}. {title}
        </Text>
        <Space size="s24" />
        {isAnswered && <Checkmark />}
        {!isAnswered && !!sideActions && <Styled.SideActions>{sideActions}</Styled.SideActions>}
      </Styled.TitleWrapper>
      {content}
    </Styled.QuestionWrapper>
  )
}
